import React, { Fragment } from 'react';
import Disclaimer from './Disclaimer';
import CarouselButtons from './CarouselButtons';
import Frame from './Frame';
import ConvertibleControls from './ConvertibleControls';
import Pager from './Pager';
import ZoomButton from './ZoomButton';

const StackedImageControl = props => {
  const {
    images,
    index,
    analyticsKey,
    onChangeIndex,
    isZoomVisible,
    onZoom
  } = props;
  return (
    <div className="carousel-controls">
      <Pager
        images={images}
        index={index}
        analyticsKey={analyticsKey}
        onChangeIndex={onChangeIndex}
        baseClassName={'carousel-controls'}
      />
      <ZoomButton
        onClick={() => onZoom(index)}
        label={''}
        className={'carousel-controls__zoom'}
        isVisible={isZoomVisible}
      />
    </div>
  );
};

const StackedImageCarousel = ({
  images,
  cgiDisclaimers,
  index,
  isConvertible,
  isTopDown,
  inverted,
  analyticsKey,
  style,
  onChangeIndex,
  onToggleTop,
  onZoom
}) => {
  const image = images[index];
  const isZoomVisible = !!image.zoom;

  const onPrev = () => {
    const prevIndex = index - 1 >= 0 ? index - 1 : images.length - 1;
    onChangeIndex(prevIndex);
  };

  const onNext = () => {
    const nextIndex = index + 1 < images.length ? index + 1 : 0;
    onChangeIndex(nextIndex);
  };

  return (
    <div
      className={`carousel carousel--overlayed ${
        inverted ? 'carousel--inverted' : ''
      }`}
      style={style}>
      <Disclaimer disclaimers={cgiDisclaimers} />
      <CarouselButtons
        isVisible={images.length > 1}
        analyticsKey={analyticsKey}
        onPrev={onPrev}
        onNext={onNext}
      />
      <ConvertibleControls
        enabled={isConvertible && !inverted}
        isTopDown={isTopDown}
        analyticsKey={analyticsKey}
        onToggle={onToggleTop}
      />
      <Frame url={image.url} />
      <StackedImageControl
        images={images}
        index={index}
        analyticsKey={analyticsKey}
        isZoomVisible={isZoomVisible}
        onZoom={onZoom}
        onChangeIndex={onChangeIndex}
      />
    </div>
  );
};

const StackedImagesCarousel = props => {
  const {
    cgiDisclaimers,
    exteriorImages,
    exteriorIndex,
    interiorImages,
    interiorIndex,
    isConvertible,
    isTopDown,
    style,
    onChangeInteriorIndex,
    onChangeExteriorIndex,
    onToggleTop,
    onZoomExterior,
    onZoomInterior
  } = props;

  return (
    <Fragment>
      <StackedImageCarousel
        cgiDisclaimers={cgiDisclaimers}
        images={exteriorImages}
        index={exteriorIndex}
        isConvertible={isConvertible}
        isTopDown={isTopDown}
        onChangeIndex={onChangeExteriorIndex}
        style={style}
        onToggleTop={onToggleTop}
        onZoom={onZoomExterior}
      />
      <StackedImageCarousel
        cgiDisclaimers={cgiDisclaimers}
        images={interiorImages}
        index={interiorIndex}
        isConvertible={isConvertible}
        isTopDown={isTopDown}
        inverted
        style={style}
        onChangeIndex={onChangeInteriorIndex}
        onToggleTop={onToggleTop}
        onZoom={onZoomInterior}
      />
    </Fragment>
  );
};

export default StackedImagesCarousel;
